import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { filter } from 'rxjs';
import { NxButtonModule } from '@aposin/ng-aquila/button';
import { NxHeadlineModule } from '@aposin/ng-aquila/headline';
import { authConfig } from '../../configs/auth.config';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    NxButtonModule,
    NxHeadlineModule,
],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit{
  private router = inject(Router);
  private oauthService = inject(OAuthService);

  ngOnInit() {
    this.oauthService.configure(authConfig);
    this.oauthService.loadDiscoveryDocumentAndLogin();

    if (this.oauthService.hasValidAccessToken()) {
      this.router.navigate(['/incident-communications']);
      return;
    }

    this.oauthService.events
      .pipe(
        filter((e) => e.type === 'token_received' || e.type === 'token_refresh_error'),
      )
      .subscribe((e) => {
        if (e.type === 'token_refresh_error') {
          localStorage.clear();
          this.oauthService.initLoginFlow();
          return;
        }

        this.router.navigate(['/incident-communications']);
      });
  }
}
